import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';

import { merchantLoginRoute, paymentsDashboardRoute } from 'src/routing/routes';
import { isLoggedIn } from 'src/services/user.service';

export default function PageNotFound() {
  const [toRoute] = useState(isLoggedIn() ? paymentsDashboardRoute : merchantLoginRoute);

  return <Redirect to={toRoute} />;
}
